import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type UserTelegramConnectionWithId = {
  idUserTelegramConnection: number;
};

// Типы для WebSocket сообщений компонента userTelegramConnections
type UserTelegramConnectionsListMessage = WebSocketMessageWithFields<'helper-telegram', {
  userTelegramConnections: unknown[];
}>;
type UserTelegramConnectionHookMessage = WebSocketMessageWithFields<'helper-telegram-hook', UserTelegramConnectionWithId & {
  chatId: number;
  username: string;
  firstName: string;
  lastName: string;
  languageCode: string;
}>;
type UserTelegramConnectionStatusMessage = WebSocketMessageWithFields<'helper-telegram-status', UserTelegramConnectionWithId & {
  token: string;
  active: boolean;
}>;
type UserTelegramConnectionDeleteMessage = WebSocketMessageWithFields<'helper-telegram-delete' | 'helper-telegram-delete-success', UserTelegramConnectionWithId & {
  newIdUserTelegramConnection: number;
  newToken: string;
}>;
type UserTelegramConnectionDeactivateMessage = WebSocketMessageWithFields<'helper-telegram-deactivate' | 'helper-telegram-deactivate-success', UserTelegramConnectionWithId>;
type UserTelegramConnectionReactivateMessage = WebSocketMessageWithFields<'helper-telegram-reactivate' | 'helper-telegram-reactivate-success', UserTelegramConnectionWithId>;

// Объединенный тип для всех сообщений
type UserTelegramConnectionsWebSocketMessage = 
  | UserTelegramConnectionsListMessage 
  | UserTelegramConnectionHookMessage 
  | UserTelegramConnectionStatusMessage 
  | UserTelegramConnectionDeleteMessage 
  | UserTelegramConnectionDeactivateMessage 
  | UserTelegramConnectionReactivateMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataUserTelegramConnections',
},
  __name: 'userTelegramConnections',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID соединения Telegram
const handleWebSocketMessage = (data: UserTelegramConnectionsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'helper-telegram':
      store.dispatch('userTelegramConnection/wsSetUserTelegramConnections', {
        userTelegramConnections: data.userTelegramConnections,
      });
      break;

    case 'helper-telegram-hook':
      store.dispatch('userTelegramConnection/wsUserTelegramConnectionHook', {
        idUserTelegramConnection: data.idUserTelegramConnection,
        chatId: data.chatId,
        username: data.username,
        firstName: data.firstName,
        lastName: data.lastName,
        languageCode: data.languageCode,
        active: true,
      });
      break;

    case 'helper-telegram-status':
      store.dispatch('userTelegramConnection/wsUserTelegramConnectionStatus', {
        idUserTelegramConnection: data.idUserTelegramConnection,
        token: data.token,
        active: data.active,
      });
      break;

    case 'helper-telegram-delete':
    case 'helper-telegram-delete-success':
      store.dispatch('userTelegramConnection/wsUserTelegramConnectionDelete', {
        idUserTelegramConnection: data.idUserTelegramConnection,
        newIdUserTelegramConnection: data.newIdUserTelegramConnection,
        newToken: data.newToken,
      });
      break;

    case 'helper-telegram-deactivate':
    case 'helper-telegram-deactivate-success':
      store.dispatch('userTelegramConnection/wsUserTelegramConnectionDeactivate', {
        idUserTelegramConnection: data.idUserTelegramConnection,
      });
      break;

    case 'helper-telegram-reactivate':
    case 'helper-telegram-reactivate-success':
      store.dispatch('userTelegramConnection/wsUserTelegramConnectionReactivate', {
        idUserTelegramConnection: data.idUserTelegramConnection,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})